import * as Base from "@base-ui/react"
import { cva, type VariantProps } from "cva"
import type { PropsWithChildren } from "react"

export function Button(props: Button.Props) {
  return <Base.Button {...props} className={Button.className(props)} />
}

export namespace Button {
  export type Props = PropsWithChildren<
    Base.Button.Props & VariantProps<typeof className>
  >

  export const className = cva({
    base: "flex items-center justify-center rounded-md font-medium",
    variants: {
      disabled: {
        true: "opacity-50",
      },
      height: {
        full: "h-full",
      },
      size: {
        xsmall: "h-[26px] gap-1 px-2 text-xs",
        small: "h-[32px] gap-2 px-2 text-sm",
        default: "h-[36px] gap-2 px-3 text-sm",
        large: "h-[48px] gap-2 px-4 text-md",
      },
      variant: {
        default:
          "border border-button-default bg-button-default-rest text-button-default hover:border-button-default-hover hover:bg-button-default-hover active:border-button-default-active active:bg-button-default-active disabled:border-button-default-disabled disabled:bg-button-default-disabled",
        primary:
          "border border-button-primary bg-button-primary-rest text-button-primary hover:border-button-primary-hover hover:bg-button-primary-hover active:border-button-primary-active active:bg-button-primary-active disabled:border-button-primary-disabled disabled:bg-button-primary-disabled",
        invisible:
          "bg-button-invisible-rest text-button-invisible hover:bg-button-invisible-hover active:bg-button-invisible-active",
      },
      width: {
        default: "w-fit",
        full: "w-full",
      },
    },
    defaultVariants: {
      size: "default",
      variant: "default",
      width: "default",
    },
  })
}
